<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      formPro: {
        direccionp: "",
        empleado: "",
        nit_proveedor: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      detalleorden: [],
      title: "Compras",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Compras",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "ordenes/view_orden?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detalleorden = response.data.orden.detalle_ordens;
          this.formPro.empleado =
            response.data.orden.user.empleado.persona.nombre_persona +
            " " +
            response.data.orden.user.empleado.persona.apellido_persona;
          this.formPro.nit_proveedo =
            response.data.orden.proveedore.nit_proveedor;
          this.formPro.proveedor =
            response.data.orden.proveedore.company_proveedor;
          this.formPro.no_orden = response.data.orden.no_orden;
          this.formPro.observaciones = response.data.orden.observaciones;
          this.formPro.fecha_compra = this.showDate(
            response.data.orden.fecha_compra
          );
          this.formPro.total = response.data.orden.total;
          this.formPro.direccionp =
            response.data.orden.proveedore.direccion_proveedor;
          //  console.log( response.data.orden)
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  /**
   * Total no. of records
   */

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6">
            <div class="mt-2">
              <h5></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <h2 id="visor_imagenes">
            <span class="blanco-rojo">Orden de Compra</span>
          </h2>
          <div class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">
                Orden# {{ this.formPro.no_orden }}
              </h4>
              <!--   <div class="mb-4">
                <img
                  src="@/assets/images/logo-dark.png"
                  alt="logo"
                  height="20"
                /> 
              </div>-->
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>Proveedor:</strong>
                  <br />
                  {{ this.formPro.proveedor }} <br />
                  <strong>NIT:</strong> <br />{{ this.formPro.nit_proveedo }}
                  <br />
                  <strong>Dirección:</strong> <br />
                  {{ this.formPro.direccionp }} <br />
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  <strong>Cotizador:</strong>
                  <br />Usuario: <br />{{ this.formPro.empleado }}
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Empresa:</strong>
                  <br />Zona Auto <br />zonaauto@email.com<br />
                  San Marcos
                </address>
              </div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Fecha de Compra:</strong>
                  <br />{{ this.formPro.fecha_compra }}
                  <!-- <br />
                  <br />
                   -->
                  <div class="col-6 mt-3 text-sm-end">
                    <address>
                      <strong>observaciones:</strong>
                      <br />Observacion: <br />{{ this.formPro.observaciones }}
                    </address>
                  </div>
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Resumen de Orden</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Producto</th>
                    <th>Codigo</th>
                    <th>Cantidad</th>
                    <th>Precio compra</th>
                    <th>Precio venta</th>
                    <th class="text-sm-end">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in this.detalleorden" v-bind:key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td>
                      {{ item.stock.producto.nombre_producto }}
                      {{ item.stock.presentacione.nombre_presentacion }}
                    </td>
                    <td>
                      {{ item.stock.codigo_stock }}
                    </td>
                    <td class="text-sm-end">{{ item.cantidad_compra }}</td>
                    <td class="text-sm-end">
                      {{ money(item.stock.precio_compra_stock) }}
                    </td>
                    <td class="text-sm-end">
                      {{ money(item.stock.precio_venta_stock) }}
                    </td>
                    <td class="text-sm-end">
                      {{ money(item.subtotal_compra) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" class="border-0 text-sm-end">
                      <strong>Total</strong>
                    </td>
                    <td class="border-0 text-sm-end">
                      <h4 class="m-0">{{ money(this.formPro.total) }}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <router-link
                  :to="{
                    name: 'ordendecompra',
                  }"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Regresar
                </router-link>
              </div>
              <!-- end col -->

              <!-- end col -->
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                  href="javascript:window.print()"
                  class="btn btn-primary w-md waves-effect waves-light me-1"
                  ><i class="fa fa-print"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
